// hooks/queries/lookups/createLookupHook.ts

import { useQuery } from "@tanstack/react-query";
import API from "@/config/api";

export function createLookupHook<T>(key: string, endpoint: string) {
  return () =>
    useQuery<T>({
      queryKey: ["lookups", key],
      queryFn: async () => {
        const res = await API.main.get<{ data: T }>(endpoint);
        return res.data?.data;
      },
      // staleTime: Infinity,
      // gcTime: Infinity,
    });
}
